module.exports = __webpack_public_path__ + "img/private-badge.9fe3f63d.svg";